<template>
  <CommonTask
    :content="nextAction.content"
    :owner="nextAction.owner"
    :title="nextAction.name"
    :date-time="nextAction.reservedAt"
    :is-sequence="isSequenceAction"
    layout-type="expandable"
  >
    <template #status>
      <BPriorityPreview
        :priority="nextAction.priority"
        size="micro"
      />
    </template>
    <template #optionalActions>
      <LinkToLead :call-target="nextAction.callTarget" />
    </template>
  </CommonTask>
</template>

<script lang="ts" setup>
import { NextAction } from '@/api/openapi';
import { useNextActionComputed } from '@/composable/user/nextAction/next-action';
import CommonTask from '../lead/task/CommonTask.vue';
import LinkToLead from './LinkToLead.vue';

type TProps = {
  nextAction: NextAction;
};

const props = defineProps<TProps>();
const { isSequenceAction } = useNextActionComputed(props.nextAction);
</script>

<style lang="scss" scoped>
.task-container {
  :deep(.task-user-area, .task-info-area, .task-content-area) {
    @include m-flex-align-center;
  }
  :deep(.task-info-area) {
    @include m-fixed-width(450px);

    .task-info-main {
      @include m-fixed-width(200px);
    }
    .task-optional-actions {
      display: block;
      margin-left: $basespace-400;
      max-width: 210px;
    }
  }
}
</style>
